import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import DistrictsList, { DispatchProps, OwnProps, StateProps } from './DistrictsList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getDistricts } from 'src/store/actions/district-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.districts.data,
        inProgress: state.districts.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getDistricts(params)),
    };
}

const DistrictsListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(DistrictsList);

export default DistrictsListScreen;
